export default {
  documentsLinks: []
};
